module.exports = __webpack_public_path__ + "static/media/r4s1.9a0a7215.jpg";